import { Injectable } from '@angular/core';
import { AuthService, Customer } from 'gung-standard';
import { ActionButton } from 'gung-common';
import { Observable, of } from 'rxjs';
import { filter, first, switchMap } from 'rxjs';
import { RefJeevesModalService } from '../ref-jeeves-modal/ref-jeeves-modal.service';

@Injectable({
  providedIn: 'root'
})
export class UserActionConfigService {
  base = [
    {
      title: 'ADD_NEW_CUSTOMER',
      action: () => {
        this.modalService.openAddCustomerModal();
      }
    }
  ];

  constructor(protected modalService: RefJeevesModalService, protected authService: AuthService) {}

  getButtons(): Observable<ActionButton<Customer>[]> {
    return this.authService.getRoles().pipe(
      filter(roles => !!roles),
      first(),
      switchMap(roles => {
        if (roles.indexOf('SALES') > -1) {
          return new Observable<ActionButton<Customer>[]>(subscriber => {
            subscriber.next(this.base);
            subscriber.complete();
          });
        } else {
          return of([]);
        }
      })
    );
  }
}
